export const COUNT_INTERVENER_LOGIN_DEFAULT_PARAM = '5';
export const COUNT_REPORTER_MESSAGES_DEFAULT_PARAM = '7';
export const COUNT_LICENCE_USAGE_DEFAULT_PARAM = '1000';
